export const recipeMethods = `
  data {
  id
    attributes {
      title
    }
  }
`;